module.exports = __webpack_public_path__ + "static/media/sidebar-4.f34e943f.jpg";